{
    "title": "Historique des ventes",
    "for": "pour"
}
